export function getFloorLabel(level) {
  return `${level.display_name || `${level.floor_number === 0 ? 'Ground floor' : `Floor ${level.floor_number}`}${level.display_name ? ` - ${level.display_name}` : ''}`}`
}
